var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-document"},_vm._l((_vm.pages),function(page){return _c('PDFPage',{key:page.pageNumber,attrs:{"page":page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }